import { Dispatch } from 'redux';
import { COOKIE_KEY, DOMAIN_ADS } from 'src/constants';
import { IStoreState } from 'src/interface';
import { Logger } from 'src/utils';
import CookieStore, { getVisitorID } from 'src/utils/cookie';
import { buildURLWithParam, fetchUrl, postWithUrl } from 'src/utils/http';
import { adNativeUpdate } from './dispatchActions';

const LOG_API = 'https://log.adtimaserver.vn/feedbacklanding/submit';

export const reFetchAdNative =
    () => (dispatch: Dispatch<any>, getState: () => IStoreState) => {
        const state = getState();
        const prZoneIds = state.ad?.prZoneIds;
        if (prZoneIds?.length) {
            dispatch(loadAdNative(prZoneIds));
        }
    };

export const loadAdNative =
    (prZoneIds: string[]) => async (dispatch: Dispatch<any>) => {
        const _API =
            ((window as any)._BM.urlAds
                ? (window as any)._BM.urlAds
                : DOMAIN_ADS) + '/zpr/baomoiPR';
        const _url = buildURLWithParam(_API, _buildParams(prZoneIds));
        fetchUrl(_url)
            .then((resp: any) => {
                // TODO
                if (resp && resp.data) {
                    const _window: any = window;
                    _window.adtimaBMConfig = {
                        ..._window.adtimaBMConfig,
                        servingToken: resp?.ext?.servingToken,
                    };
                    dispatch(
                        adNativeUpdate({
                            prZoneIds,
                            adData: resp.data,
                        })
                    );
                }
            })
            .catch((err: any) => {
                if (err) {
                    Logger.errorWithType(
                        'ads',
                        err.err || 'Adtima',
                        'loadAdNative Fail|',
                        err
                    );
                    dispatch(
                        adNativeUpdate({
                            prZoneIds,
                            adData: undefined,
                        })
                    );
                }
            });
    };

function _buildParams(zoneIds: string[] = []) {
    const _window: any = window;
    const isZalo = _window._BM.installZalo
        ? `iszalo=${_window._BM.installZalo};`
        : '';
    const params = {
        zones: zoneIds.join(','),
        vs: `${isZalo}cate=${_window.cate_path};curl=${window.location.href}`,
        count: 1,
        uid: getVisitorID()
            ? getVisitorID()
            : CookieStore.get(COOKIE_KEY.BM_UID),
    } as any;

    if (_window.adConfig?.contentId) {
        params['contentId'] = _window.adConfig.contentId;
    }

    if (typeof _window.ZA !== 'undefined') {
        params['ver'] = `za_version=${_window.ZA.version}`;
    }
    return params;
}

export const pushLogAdNative = (params: any) => {
    postWithUrl(LOG_API, params)
        .then((resp: any) => {})
        .catch((err) => {
            if (err) {
                Logger.error(err.err, 'pushLogAdNative|', err.msg);
            }
        });
};
